var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagnose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.150391,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 21.817C13.6507 21.817 13.45 21.752 13.2729 21.6222C13.0958 21.4923 12.966 21.327 12.8833 21.1263L11.2542 16.8586H8.91668C8.71598 16.8586 8.54787 16.7906 8.41235 16.6546C8.27682 16.5186 8.20882 16.3505 8.20835 16.1503C8.20787 15.9501 8.27587 15.782 8.41235 15.646C8.54882 15.51 8.71693 15.442 8.91668 15.442H11.75C11.9035 15.442 12.0364 15.4833 12.1488 15.5659C12.2612 15.6486 12.3467 15.7607 12.4052 15.9024L13.875 19.7628L17.1333 11.1743C17.216 10.9736 17.3458 10.8083 17.5229 10.6784C17.7 10.5486 17.9007 10.4836 18.125 10.4836C18.3493 10.4836 18.55 10.5486 18.7271 10.6784C18.9042 10.8083 19.034 10.9736 19.1167 11.1743L20.7458 15.442H23.0833C23.284 15.442 23.4524 15.51 23.5884 15.646C23.7244 15.782 23.7922 15.9501 23.7917 16.1503C23.7912 16.3505 23.7232 16.5189 23.5877 16.6553C23.4522 16.7918 23.284 16.8596 23.0833 16.8586H20.25C20.0965 16.8586 19.9638 16.8173 19.8519 16.7347C19.74 16.652 19.6543 16.5399 19.5948 16.3982L18.125 12.5378L14.8667 21.1263C14.784 21.327 14.6542 21.4923 14.4771 21.6222C14.3 21.752 14.0993 21.817 13.875 21.817Z",
    fill: "#155DFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnose);
export default __webpack_public_path__ + "static/media/Diagnose.fb1403fa9efeba111394489a51419f3b.svg";
export { ForwardRef as ReactComponent };